<template>
  <header class="overall-header border-b">
    <div class="overall-header__top flex items-center gap-4 mb-3 text-10">
      <button class="icon-btn bg-white shadow-sm" type="button" :aria-label="$t('app.assessment_mode.coming_soon.back')" @click="handleBack">
        <v-icon small>{{ icons.mdiChevronLeft }}</v-icon>
      </button>

      <div class="patient-meta">
        <div class="patient-meta__item">
          <span class="label">{{ $t('app.assessment_mode.text.input.patient_id_label') }}</span>
          <span class="value">{{ patient.id }}</span>
        </div>
        <div class="patient-meta__item">
          <span class="label">{{ $t('app.assessment_mode.text.input.field.gender') }}</span>
          <span class="value">{{ patient.gender }}</span>
        </div>
        <div class="patient-meta__item">
          <span class="label">{{ $t('app.assessment_mode.text.input.field.age') }}</span>
          <span class="value">{{ patient.age }}</span>
        </div>
      </div>

    </div>

    <div class="overall-header__steps">
      <div class="step-indicators">
        <div class="step-item">
          <span v-if="isRiskAssessment" class="step-circle step-circle--active">1</span>
          <span v-else class="step-circle step-circle--done">
            <v-icon x-small color="white">{{ icons.mdiCheck }}</v-icon>
          </span>
          <span class="step-label" :class="{ 'step-label--active': isRiskAssessment }">
            {{ $t('app.assessment_mode.text.input.risk_assessment_tab') }}
          </span>
        </div>

        <div class="step-connector" :class="{ 'step-connector--active': isCarePlan || isFinalize }"></div>

        <div class="step-item">
          <span v-if="isCarePlan" class="step-circle step-circle--active">2</span>
          <span v-else-if="isFinalize" class="step-circle step-circle--done">
            <v-icon x-small color="white">{{ icons.mdiCheck }}</v-icon>
          </span>
          <span v-else class="step-circle step-circle--upcoming">2</span>
          <span class="step-label" :class="{ 'step-label--active': isCarePlan }">
            {{ $t('app.assessment_mode.text.input.care_plan_tab') }}
          </span>
        </div>

        <div class="step-connector" :class="{ 'step-connector--active': isFinalize }"></div>

        <div class="step-item">
          <span v-if="isFinalize" class="step-circle step-circle--active">3</span>
          <span v-else-if="finalizeLocked" class="step-circle step-circle--locked">
            <v-icon x-small color="#9ab0bb">{{ icons.mdiLock }}</v-icon>
          </span>
          <span v-else class="step-circle step-circle--upcoming">3</span>
          <span class="step-label" :class="{ 'step-label--active': isFinalize }">
            {{ $t('app.assessment_mode.text.input.finalize_and_save') }}
          </span>
        </div>
      </div>

      <button class="review-btn shadow-sm rounded-lg" type="button" @click="$emit('review-data')">
        {{ $t('app.assessment_mode.text.input.review_data') }}
      </button>
    </div>
  </header>
</template>

<script lang="ts">
import icons from '@/mixins/icons'
import { defineComponent, PropType } from "vue";
import { JourneyStage, PatientInfo } from "../types/overall-assessment.types";

export default defineComponent({
  name: 'OverallAssessmentHeader',
  mixins: [icons],
  props: {
    patient: {
      type: Object as PropType<PatientInfo>,
      required: true,
    },
    activeTab: {
      type: String,
      required: true,
    },
    stage: {
      type: String as PropType<JourneyStage>,
      required: true,
    },
    hasNoRisk: {
      type: Boolean,
      default: false,
    },
    hasVisitedCarePlan: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isRiskAssessment(): boolean {
      return this.stage === 'assessment' && this.activeTab === 'Risk Assessment';
    },
    isCarePlan(): boolean {
      return this.stage === 'assessment' && this.activeTab === 'Care Plan';
    },
    isFinalize(): boolean {
      return this.stage === 'finalize';
    },
    finalizeLocked(): boolean {
      return !this.hasVisitedCarePlan && !this.hasNoRisk;
    },
  },
  methods: {
    handleBack() {
      this.$router.back();
    },
  },
})
</script>
